/**
 * Named aliases for primary keys that can't be written literally in a combo
 * string, consumed by `parseCombo` (`src/shared/lib/keyCombo.ts`).
 *
 * Keys are the alias token as it appears in a `+`-joined combo (lowercased);
 * values are the `KeyboardEvent.key` the alias resolves to. `' '` (the
 * spacebar's `key`) would be trimmed away to an empty token, so it is spelled
 * `space`. Add an entry here — not at a call site — whenever a new key's `key`
 * value is unwritable in a combo.
 */
export const KEY_ALIASES: Record<string, string> = { space: ' ', spacebar: ' ' };
